import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const api = {
  getAllItems: () => axios.get(`${API_URL}/checklist`),
  createItem: (data) => axios.post(`${API_URL}/checklist`, data),
  updateItem: (id, data) => axios.put(`${API_URL}/checklist/${id}`, data),
  deleteItem: (id) => axios.delete(`${API_URL}/checklist/${id}`),
  resetChecklist: (data) => axios.post(`${API_URL}/checklist/reset`, data)
};